var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMove = function SvgMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 26h2a8 8 0 0 1 8 8v36a8 8 0 0 1-8 8H0",
    stroke: "currentColor",
    strokeWidth: 2.77
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.385,
    y: 10.385,
    width: 61.23,
    height: 83.23,
    rx: 6.615,
    stroke: "currentColor",
    strokeWidth: 2.77
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104 26h-2a8 8 0 0 0-8 8v36a8 8 0 0 0 8 8h2",
    stroke: "currentColor",
    strokeWidth: 2.77
  })));
};
export { SvgMove as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDEwNCAxMDQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wIDI2SDJDNi40MTgyOCAyNiAxMCAyOS41ODE3IDEwIDM0VjcwQzEwIDc0LjQxODMgNi40MTgyOCA3OCAyIDc4SDAiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIuNzciLz4KPHJlY3QgeD0iMjEuMzg1IiB5PSIxMC4zODUiIHdpZHRoPSI2MS4yMyIgaGVpZ2h0PSI4My4yMyIgcng9IjYuNjE1IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyLjc3Ii8+CjxwYXRoIGQ9Ik0xMDQgMjZIMTAyQzk3LjU4MTcgMjYgOTQgMjkuNTgxNyA5NCAzNFY3MEM5NCA3NC40MTgzIDk3LjU4MTcgNzggMTAyIDc4SDEwNCIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMi43NyIvPgo8L3N2Zz4K";